export enum ScreenType {
    LEFT,
    RIGHT
}
